export const CognitoErrors = {
  USER_NOT_FOUND: "UserNotFoundException",
  NOT_AUTHORIZED: "NotAuthorizedException",
  RESET_REQUIRED: "PasswordResetRequiredException",
  USER_LAMBDA_VALIDATION: "UserLambdaValidationException",
  INVALID_PARAMETER: "InvalidParameterException",
};
